jQuery(document).ready(function($) {
  if($('.join-our-team-slider').length) {
    $('.join-our-team-slider').slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
  }
});
